"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _react = _interopRequireDefault(require("react"));
var _semanticUiReact = require("semantic-ui-react");
var _MenuItem = _interopRequireDefault(require("./MenuItem"));
function _createSuper(Derived) {
  return function () {
    var Super = (0, _getPrototypeOf2["default"])(Derived),
      result;
    if (_isNativeReflectConstruct()) {
      var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return (0, _possibleConstructorReturn2["default"])(this, result);
  };
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
var MenuSection = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(MenuSection, _React$Component);
  var _super = _createSuper(MenuSection);
  function MenuSection() {
    var _this;
    (0, _classCallCheck2["default"])(this, MenuSection);
    _this = _super.call(this);
    _this.state = {
      active: false
    };
    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }
  (0, _createClass2["default"])(MenuSection, [{
    key: "handleClick",
    value: function handleClick() {
      var active = this.state.active;
      this.setState({
        active: !active
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        asAccordion = _this$props.asAccordion,
        centerHeaders = _this$props.centerHeaders,
        imageSize = _this$props.imageSize,
        itemAs = _this$props.itemAs,
        itemsPerRow = _this$props.itemsPerRow,
        sectionItems = _this$props.sectionItems,
        sectionTitle = _this$props.sectionTitle,
        sectionDescription = _this$props.sectionDescription;
      var active = this.state.active;
      if (asAccordion) {
        return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Accordion, {
          style: {
            margin: '0 0 2.5rem 0'
          },
          id: sectionTitle
        }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Accordion.Title, {
          active: active,
          onClick: this.handleClick
        }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid, {
          columns: 1,
          centered: centerHeaders
        }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Header, {
          as: "h2"
        }, sectionTitle)), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid, {
          columns: 1,
          centered: centerHeaders
        }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Header, {
          as: "h4",
          style: {
            marginTop: '0.2em'
          }
        }, sectionDescription)), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid, {
          columns: 1,
          centered: centerHeaders,
          style: {
            marginBottom: '2em',
            textAlign: "".concat(centerHeaders ? 'center' : 'left')
          }
        }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Button, {
          style: {
            background: 'none',
            border: 'none'
          },
          onClick: this.handleClick
        }, active ? 'Show Less' : 'Show More'))), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Accordion.Content, {
          active: active
        }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid, {
          columns: itemsPerRow,
          stackable: true,
          style: {
            textAlign: centerHeaders ? 'center' : 'left'
          }
        }, sectionItems.map(function (item) {
          return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Column, {
            key: item.itemTitle
          }, /*#__PURE__*/_react["default"].createElement(_MenuItem["default"], (0, _extends2["default"])({}, item, {
            imageSize: imageSize,
            itemAs: itemAs,
            align: centerHeaders ? 'center' : 'left'
          })));
        }))));
      }
      return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Container, {
        id: sectionTitle
      }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid, {
        columns: 1,
        centered: centerHeaders
      }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Divider, {
        section: true
      })), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid, {
        columns: 1,
        centered: centerHeaders
      }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Header, {
        as: "h2"
      }, sectionTitle)), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid, {
        columns: 1,
        centered: centerHeaders
      }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Header, {
        as: "h4",
        style: {
          marginTop: '0.2em',
          marginBottom: '2em'
        }
      }, sectionDescription)), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid, {
        columns: itemsPerRow,
        stackable: true,
        style: {
          textAlign: centerHeaders ? 'center' : 'left'
        }
      }, sectionItems.map(function (item) {
        return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Column, {
          key: item.itemTitle
        }, /*#__PURE__*/_react["default"].createElement(_MenuItem["default"], (0, _extends2["default"])({}, item, {
          align: centerHeaders ? 'center' : 'left',
          imageSize: imageSize,
          itemAs: itemAs
        })));
      })));
    }
  }]);
  return MenuSection;
}(_react["default"].Component);
exports["default"] = MenuSection;